module.exports = __webpack_public_path__ + "img/2.4ae5b8bf.jpg";